module.exports = __webpack_public_path__ + "images/feature/20161107_04-9efe67984bee38a1c374625e86992cf4.jpg";